export {
  Telemetry,
  RawTelemetryEvent,
  addTelemetryDebug,
  addTelemetryError,
  startFakeTelemetry,
  resetTelemetry,
  startTelemetry,
  isTelemetryReplicationAllowed,
} from './telemetry'
export * from './telemetryEvent.types'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-core/src/domain/telemetry/index.ts